<template>
  <div class="animated fadeIn">
    <b-row>
      <OEMBacklogStacked
        :lgSize="12"
        :lgOffset="0"
        :locParam="1"
        :idCity="0"
      ></OEMBacklogStacked>

      <OEMDeliveredStacked
        :lgSize="12"
        :lgOffset="0"
        :locParam="1"
        :idCity="0"
      ></OEMDeliveredStacked>
    </b-row>
  </div>
</template>

<script>
import OEMBacklogStacked from "../../../components/oem-repair/BacklogStackedOEM.vue";
import OEMDeliveredStacked from "../../../components/oem-repair/DeliveredStackedOEM.vue";

export default {
  name: "OemRepair",
  components: {
    OEMBacklogStacked,
    OEMDeliveredStacked
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
